import './faq.css';
import imgbg from '../../assets/images/Odoo/faq.jpg';

export default function Faq() {
    return (
        <section
            className="elementor-section elementor-top-section elementor-element elementor-element-827a9db elementor-section-stretched elementor-section-content-middle elementor-section-boxed elementor-section-height-default elementor-section-height-default"
            data-id="827a9db"
            data-element_type="section"
            data-settings='{"stretch_section":"section-stretched","background_background":"classic"}'
        >
            <div className="elementor-container elementor-column-gap-extended">

                {/* LEFT COLUMN */}
                <div
                    className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-1e7625a"
                    data-id="1e7625a"
                    data-element_type="column"
                >
                    <div className="elementor-widget-wrap elementor-element-populated">

                        {/* Heading 1 */}
                        <div className="react-heading default title-border-no">
                            <div className="title-inner no">
                                {/* <span className="sec-title_title">FAQ</span> */}
                                <h2 className="title odoo-title">Odoo Implementation FAQ</h2>
                            </div>
                        </div>

                        {/* FAQ ACCORDION */}
                        <div className="rts-accordion style2" id="faqAccordion">

                            
                            {/* ITEM 1 - OPEN */}
                            <div className="accordion-item">
                                <div className="accordion-header" id="heading-1">
                                    <button
                                        className="accordion-button"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapse-1"
                                        aria-expanded="true"
                                        aria-controls="collapse-1"
                                    >
                                        <span>01.</span>
                                        What is the typical timeline for Odoo ERP implementation?
                                        <span className="accordion-icon">+</span>
                                        <span className="accordion-icon-active">−</span>
                                    </button>
                                </div>
                                <div
                                    id="collapse-1"
                                    className="accordion-collapse collapse show"
                                    aria-labelledby="heading-1"
                                    data-bs-parent="#faqAccordion"
                                >
                                    <div className="accordion-body">
                                        The implementation timeline depends on the complexity of your business requirements. A basic setup can take a few weeks, while a fully customized solution may take a few months.
                                    </div>
                                </div>
                            </div>

                            {/* ITEM 2 */}
                            <div className="accordion-item">
                                <div className="accordion-header" id="heading-2">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapse-2"
                                        aria-expanded="false"
                                        aria-controls="collapse-2"
                                    >
                                        <span>02.</span>
                                        Can I migrate my existing data to Odoo?
                                        <span className="accordion-icon">+</span>
                                        <span className="accordion-icon-active">−</span>
                                    </button>
                                </div>
                                <div
                                    id="collapse-2"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="heading-2"
                                    data-bs-parent="#faqAccordion"
                                >
                                    <div className="accordion-body">
                                        Yes, we offer seamless data migration from legacy systems to Odoo, ensuring minimal disruption and data integrity.
                                    </div>
                                </div>
                            </div>

                            {/* ITEM 3 */}
                            <div className="accordion-item">
                                <div className="accordion-header" id="heading-3">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapse-3"
                                        aria-expanded="false"
                                        aria-controls="collapse-3"
                                    >
                                        <span>03.</span>
                                        Is Odoo suitable for small businesses?
                                        <span className="accordion-icon">+</span>
                                        <span className="accordion-icon-active">−</span>
                                    </button>
                                </div>
                                <div
                                    id="collapse-3"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="heading-3"
                                    data-bs-parent="#faqAccordion"
                                >
                                    <div className="accordion-body">
                                        Absolutely! Odoo is highly scalable and can be customized for businesses of all sizes, from startups to large enterprises.
                                    </div>
                                </div>
                            </div>

                            {/* ITEM 4 */}
                            <div className="accordion-item">
                                <div className="accordion-header" id="heading-4">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapse-4"
                                        aria-expanded="false"
                                        aria-controls="collapse-4"
                                    >
                                        <span>04.</span>
                                        What kind of support do you provide after implementation?
                                        <span className="accordion-icon">+</span>
                                        <span className="accordion-icon-active">−</span>
                                    </button>
                                </div>
                                <div
                                    id="collapse-4"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="heading-4"
                                    data-bs-parent="#faqAccordion"
                                >
                                    <div className="accordion-body">
                                        We offer post-implementation support, including troubleshooting, system updates, employee training, and further customizations if needed.
                                    </div>
                                </div>
                            </div>

                            {/* ITEM 5 */}
                            <div className="accordion-item">
                                <div className="accordion-header" id="heading-5">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapse-5"
                                        aria-expanded="false"
                                        aria-controls="collapse-5"
                                    >
                                        <span>05.</span>
                                        How much does Odoo implementation cost?
                                        <span className="accordion-icon">+</span>
                                        <span className="accordion-icon-active">−</span>
                                    </button>
                                </div>
                                <div
                                    id="collapse-5"
                                    className="accordion-collapse collapse"
                                    aria-labelledby="heading-5"
                                    data-bs-parent="#faqAccordion"
                                >
                                    <div className="accordion-body">
                                        The cost varies based on the modules required, customization needs, and the scale of implementation. Contact us for a tailored quote.
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                {/* RIGHT COLUMN */}
                <div
                    className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-9440bc2"
                >
                    <div className="elementor-widget-wrap elementor-element-populated">
                        <img src={imgbg}></img>
                    </div>
                </div>

            </div>
        </section>
    );
}
